import React from 'react';
import { SpanTag } from '../../Utils/AtomicTag';
export var BreadcrumbSeparator = function (props) {
    var separatorCls = ['text-gray-600', 'text-sm', 'mx-1'];
    return React.createElement(SpanTag, { atomics: separatorCls }, props.children || '/');
};
